



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const pollingInterval = 15000;

@Component
export default class WaitingMessage extends Vue {
  @Prop() outlet!: string;
  alertMessage: string = 'New Waiting! ';
  showAlert: boolean = false;
  intervalTimer: any = null;
  intervalManager: any = null;

  mounted() {
    if (
      !window.navigator.userAgent.includes('iPhone') &&
      !window.navigator.userAgent.includes('Android') &&
      !window.navigator.userAgent.includes('ipad')
    ) {
      this.intervalManager = this.messagePolling(() => {
        this.$store.dispatch('GetNewWaitingRequest', { outletCode: this.outlet });
      });
      this.intervalTimer = setTimeout(() => {
        this.intervalManager.start();
      }, pollingInterval);
    }
  }

  beforeDestroy() {
    this.intervalManager.stop();
    clearTimeout(this.intervalTimer);
    this.$store.commit('SET_HAS_WAITING', false);
  }

  get hasNewWaiting() {
    return this.$store.getters.GetHasNewWaiting;
  }

  messagePolling(callback) {
    let timerId;
    const loop = async () => {
      await callback();
      return (timerId = setTimeout(loop, pollingInterval));
    }
    return {
      start: () => {
        loop();
      },
      stop: () => {
        clearTimeout(timerId);
      }
    };
  }

  closeNewAlert() {
    this.showAlert = false;
    this.$store.commit('SET_HAS_WAITING', false);
  }

  @Watch('hasNewWaiting')
  watchNewWaiting(value) {
    if (value) {
      this.showAlert = true;
    }
  }

  handleClick() {
    this.closeNewAlert();
    this.$emit('request');
  }
}
